import React from 'react';
import PropTypes from 'prop-types';

import {
    SAVED_LISTS_BENEFITS,
    SAVED_LISTS_PREVIEW_IMAGE_ALT,
    SAVED_LISTS_PREVIEW_IMAGE_SRC,
} from '../constants';
import styles from './savedListsBenefitsPanel.scss';

const SavedListsBenefitsPanel = ({
    'data-testid': dataTestId,
    heading,
    showPreview,
    panelClassName,
    previewClassName,
    children,
}) => (
    <div className={styles.container} data-testid={dataTestId}>
        <div className={panelClassName ? `${styles.panel} ${panelClassName}` : styles.panel}>
            <h3 className={styles.heading} data-testid={dataTestId && `${dataTestId}.heading`}>
                {heading}
            </h3>
            <ul className={styles.bullets} data-testid={dataTestId && `${dataTestId}.bullets`}>
                {SAVED_LISTS_BENEFITS.map(benefit => (
                    <li
                        key={benefit.key}
                        className={styles.bullet}
                        data-testid={dataTestId && `${dataTestId}.bullets.${benefit.key}`}
                    >
                        {benefit.text}
                    </li>
                ))}
            </ul>
            {children}
        </div>
        {showPreview && (
            <img
                className={previewClassName ? `${styles.preview} ${previewClassName}` : styles.preview}
                src={SAVED_LISTS_PREVIEW_IMAGE_SRC}
                alt={SAVED_LISTS_PREVIEW_IMAGE_ALT}
                loading="lazy"
                data-testid={dataTestId && `${dataTestId}.preview`}
            />
        )}
    </div>
);

SavedListsBenefitsPanel.propTypes = {
    'data-testid': PropTypes.string,
    heading: PropTypes.string.isRequired,
    showPreview: PropTypes.bool,
    panelClassName: PropTypes.string,
    previewClassName: PropTypes.string,
    children: PropTypes.node,
};

SavedListsBenefitsPanel.defaultProps = {
    'data-testid': null,
    showPreview: true,
    panelClassName: null,
    previewClassName: null,
    children: null,
};

export default SavedListsBenefitsPanel;
